<template>
    <div>
        <b-list-group class="border-top" flush>
            <b-list-group-item class="article-pedigree-chart">
                <div class="h6 mb-3 mt-3 d-flex">
                    <span
                        class="collapse-icon mr-2 d-flex justify-content-center align-items-center"
                        :class="{'collapsed': !media_pedigree_visible}"
                        :aria-expanded="media_pedigree_visible ? 'true' : 'false'"
                        @click="()=> { media_pedigree_visible = !media_pedigree_visible}"
                    >
                        <span class="open">
                            <font-awesome-icon :icon="['fas', 'caret-down']" fixed-width />
                        </span>
                        <span class="closed">
                            <font-awesome-icon :icon="['fas', 'caret-right']" fixed-width />
                        </span>
                    </span>
                    <span
                        class="text-dark mr-1 cursor-pointer"
                        @click="()=> { media_pedigree_visible = !media_pedigree_visible}"
                    >
                        Pedigree Chart
                    </span>
                </div>
                <b-collapse
                    v-model="media_pedigree_visible"
                    :class="media_pedigree_visible ? null : 'collapsed'"
                >
                    <div v-if="pedigree_loading">
                        <b-spinner small label="Loading Pedigrree..."></b-spinner>
                        Loading Pedigree
                    </div>
                    <div v-else>
                        <b-alert
                            variant="danger"
                            :show="!editing_media_pedigree_data || editing_media_pedigree_data && !editing_media_pedigree_data.length"
                            class="my-2"
                        >
                            No Pedigree Found
                        </b-alert>
                        <div v-if="editing_media_pedigree_data && editing_media_pedigree_data.length" class="d-md-flex align-items-center my-3">
                            <!-- page search -->
                            <div class="flex-grow-1 mr-1 mb-md-0 mb-3">
                                <b-form-input type="search" v-model="search_term" placeholder="Search" />
                            </div>
    
                            <div class="d-flex flex-grow-1 mr-1 mb-md-0 mb-3 col-4">
                                <div class="w-100">
                                    <div class="d-flex align-items-center">
                                        <div class="flex-grow-1">
                                            <div class="row align-items-center">
                                                <div class="col-lg">
    
                                                    <multiselect
                                                        v-if="is_printables"
                                                        :select-label="select_label"
                                                        :deselect-label="deselect_label"
                                                        v-model="filters.pedigree_types"
                                                        :options="printables_pedigree_types"
                                                        label="name"
                                                        track-by="pedigree_type"
                                                        placeholder="Pedigree Type"
                                                        multiple
                                                    />
                                                    <multiselect
                                                        v-else
                                                        :select-label="select_label"
                                                        :deselect-label="deselect_label"
                                                        v-model="filters.pedigree_types"
                                                        :options="media_pedigree_types"
                                                        label="name"
                                                        track-by="pedigree_type"
                                                        placeholder="Pedigree Type"
                                                        multiple
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <CopyToClipboardButton
                                v-if="copyablePedigreeRows.length"
                                size="sm"
                                class="mb-md-0 mb-3"
                                :value="copyablePedigreeHtml"
                                :as-html="true"
                            />
                        </div>
                        <b-table
                            v-if="filteredPedigree && editing_media_pedigree_data && editing_media_pedigree_data.length"
                            :items="filteredPedigree"
                            :fields="fields"
                            striped
                            responsive
                            sticky-header
                            outlined
                            no-border-collapse
                            head-variant="light"
                            class="mt-3"
                        >
                            <template #cell(publication_sku)="data">
                                <div>
                                    <router-link :to="{path: '/publications/' + data.item.publication_id}" target="_blank">
                                        {{data.item.publication_sku}}
                                    </router-link>
                                    <div
                                        v-if="data.item.publication_category === 'retired'"
                                        class="text-danger font-italic small"
                                    >
                                        Retired
                                    </div>
                                </div>
                            </template>
                            <template #cell(unit_group_title)="data">
                                <div v-if="data.item.unit_group_id">
                                    <span class="mr-1">{{data.item.unit_number}}.</span>
                                    <span v-if="data.item.publication_id">
                                        <router-link :to="{path: '/publications/' + data.item.publication_id, query: { unit_group_id: data.item.unit_group_id }}" target="_blank">
                                            <span v-if="data.item.unit_group_title">{{data.item.unit_group_title}}</span><span v-else class="text-muted">no title</span>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        <span v-if="data.item.unit_group_title">{{data.item.unit_group_title}}</span><span v-else class="text-muted">no title</span>
                                    </span>
                                </div>
                            </template>
                            <template #cell(unit_title)="data">
                                <div v-if="data.item.unit_id">
                                    <span class="mr-1">{{data.item.week_number}}.</span>
                                    <span v-if="data.item.publication_id">
                                        <router-link :to="{path: '/publications/' + data.item.publication_id, query: { unit_id: data.item.unit_id }}" target="_blank">
                                            <span v-if="data.item.unit_title">{{data.item.unit_title}}</span><span v-else class="text-muted">no title</span>
                                        </router-link>
                                    </span>
                                    <span v-else>
                                        <span v-if="data.item.unit_title">{{data.item.unit_title}}</span><span v-else class="text-muted">no title</span>
                                    </span>
                                </div>
                            </template>
                            <template #cell(article_title)="data">
                                <router-link v-if="data.item.article_id" :to="{path: '/publications/' + data.item.publication_id, query: { unit_id: data.item.unit_id, article_id: data.item.article_id  }}" target="_blank">
                                    <span v-if="data.item.article_title">{{data.item.article_title}}</span><span v-else class="text-muted">no title</span>
                                </router-link>
                            </template>
                        </b-table>                 
                    </div>


                </b-collapse>
                
            </b-list-group-item>
        </b-list-group>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    import CopyToClipboardButton from '@/components/CopyToClipboardButton'
    import media_pedigree_types from '@/common/media_pedigree_types'
    import printables_pedigree_types from '@/common/printables_pedigree_types'

    export default {
        components: {
            CopyToClipboardButton,
        },
        data: () => ({
            media_pedigree_types: media_pedigree_types,
            printables_pedigree_types: printables_pedigree_types,
            media_pedigree_visible: false,
            search_term: '',
            select_label: '',
            deselect_label: 'remove',
            filters: {pedigree_types: []},
            fields: [
            {
                key: 'source',
                sortable: true,
                thStyle: { width: "10%" },
                thClass: 'text-center',
                tdClass: 'text-center',
            },
            {
                key: 'publication_sku',
                label: 'Publication',
                sortable: true,
                thStyle: { width: "15%" },
                thClass: 'text-center',
                tdClass: 'text-center',
            },
            {
                key: 'unit_group_title',
                label: 'Unit',
                sortable: true,
                thStyle: { width: "15%" },
                thClass: 'text-center',
            },
            {
                key: 'unit_title',
                label: 'Week',
                sortable: true,
                thStyle: { width: "15%" },
                thClass: 'text-center',
            },
            {
                key: 'article_title',
                label: 'Article',
                sortable: true,
                thStyle: { width: "15%" },
                thClass: 'text-center',
            },
        ],
        }),
        props: [
            'editing_media_pedigree_data',
            'is_printables',
            'pedigree_loading'
        ],
        computed: {
            filteredPedigree() {
                if (!Array.isArray(this.editing_media_pedigree_data)) return [];
                return this.editing_media_pedigree_data.filter(media => {
                    let search = this.search_term.toLowerCase()

                    let search_match = false
                    if (
                        search == '' ||
                        media.publication_sku.toLowerCase().indexOf(search) > -1 ||
                        media.source.toLowerCase().indexOf(search) > -1 ||
                        (media.unit_group_title && media.unit_group_title.toLowerCase().indexOf(search) > -1) ||
                        (media.unit_title && media.unit_title.toLowerCase().indexOf(search) > -1) ||
                        (media.article_title && media.article_title.toLowerCase().indexOf(search) > -1)
                        
                    ) {
                        search_match = true
                    }

                    // Media Pedigree Type filter
                    let pedigree_type_match = false
                    if (_.find(this.filters.pedigree_types, { pedigree_type: media.pedigree_type })) {
                        pedigree_type_match = true
                    }
                    pedigree_type_match = pedigree_type_match || !this.filters.pedigree_types.length

                    return search_match && pedigree_type_match
    
                })

            },
            copyablePedigreeRows() {
                if (!this.filteredPedigree.length) {
                    return []
                }

                return [
                    ['Source', 'Publication', 'Unit', 'Week', 'Article'],
                    ...this.filteredPedigree.map((item) => {
                        return [
                            item.source,
                            item.publication_category === 'retired'
                                ? `${item.publication_sku} (Retired)`
                                : item.publication_sku,
                            item.unit_group_id ? `${item.unit_number}. ${item.unit_group_title || 'no title'}` : '',
                            item.unit_id ? `${item.week_number}. ${item.unit_title || 'no title'}` : '',
                            item.article_id ? item.article_title || 'no title' : '',
                        ]
                    }),
                ]
            },
            copyablePedigreeHtml() {
                return this.rowsToHtml(this.copyablePedigreeRows)
            },
        },
        methods: {
            formatClipboardCell(value) {
                return String(value || '').replace(/\s+/g, ' ').trim()
            },
            rowsToHtml(rows) {
                const tableRows = rows.map((row, rowIndex) => {
                    const cellTag = rowIndex === 0 ? 'th' : 'td'
                    const cells = row.map((cell) => {
                        return `<${cellTag}>${this.formatClipboardCell(cell)}</${cellTag}>`
                    }).join('')

                    return `<tr>${cells}</tr>`
                }).join('')

                return `<table>${tableRows}</table>`
            },
        },
        mounted () {
        },
    }
</script>
